import type { ServerProvider } from "@amoreg/contracts";

/** Older or disconnected servers cannot promise a durable provider-history rewind. */
export function supportsConversationRollback(
  provider:
    | Pick<ServerProvider, "supportsConversationRollback" | "enabled" | "status">
    | null
    | undefined,
): boolean {
  return (
    provider?.supportsConversationRollback === true &&
    provider.enabled &&
    provider.status === "ready"
  );
}
